import { fetchPage, postPage } from "@/services/config";
import type { RawEmailSettings } from "@/types";
import type { DkimDomain } from "@/types";

const serviceBase = "branding";

export function fetchEmailPreferences(tenantId: number): Promise<RawEmailSettings> {
  return fetchPage<RawEmailSettings>(serviceBase, `/company/${tenantId}/email_settings`);
}

export function saveEmailPreferences(tenantId: number, payload: FormData): Promise<{
  msg: string;
  data: RawEmailSettings;
}> {
  return postPage<{ msg: string; data: RawEmailSettings }, FormData>(
    serviceBase,
    `/company/${tenantId}/email_settings/update`,
    payload
  );
}

export function sendTestEmail(tenantId: number): Promise<{ msg: string }> {
  return postPage<{ msg: string }>("cwacc", `/user/settings/tenant_id/${tenantId}/test`, { test_email_settings: true });
}

export function updateCwaccSettings(tenantId: number, payload: {
  is_configured_email_settings: boolean;
  is_configured_payment_settings: boolean;
}): Promise<{ msg: string }> {
  return postPage<{ msg: string }>("cwacc", `/user/settings/tenant_id/${tenantId}`, payload);
}

export function verifyEmailDomain(tenantId: number, paymentFqdn: string): Promise<{ verified_status: string; }> {
  return postPage<{ verified_status: string }>(
    serviceBase,
    `/company/${tenantId}/payment_fqdn/verify`,
    { payment_fqdn: paymentFqdn }
  );
}

export function addDkimDomain(tenantId: number, domain: string): Promise<{ dkim: DkimDomain }> {
  return postPage<{ dkim: DkimDomain }>(
    serviceBase,
    `/company/${tenantId}/email_settings/add_domain`,
    { domain }
  );
}

export function removeDkimDomain(tenantId: number, id: string): Promise<{
  msg: string;
  id: string;
}> {
  return postPage<{ msg: string; id: string }>(
    serviceBase,
    `/company/${tenantId}/email_settings/delete_domain/${id}`,
    {},
    {},
    "DELETE"
  );
}

export function verifyDkimDomain(tenantId: number, id: string): Promise<{
  dkim: DkimDomain;
}> {
  return fetchPage<{ dkim: DkimDomain }>(
    serviceBase,
    `/company/${tenantId}/email_settings/verify_domain/${id}`
  );
}
